<template>
  <div class="top-fixed-header">
    <div class="header-logo">
      <!--<img v-src-logo="schoolInfo.logo" @click="$router.replace({path: '/'})">-->
      <!--{{schoolInfo.name}}-->
      <span style="padding: 0 35px 0 15px">{{cTitle}}</span>
      <img class="ico_menu" v-src-cdn="'static/icon/menu/menu.png'" @click="toggleSiderBar" v-show="sideBarShow">
      <img class="ico_menu" v-src-cdn="'static/icon/menu/menu_down.png'" @click="toggleSiderBar" v-show="!sideBarShow">
    </div>
    <div class="right-tools">
      <div class="eos-jump" @click="goToEos">EOS平台</div>

      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <span class="name">{{userInfo && userInfo.nickname || '管理员'}}</span>
          <i class="el-icon-caret-bottom"/>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item class="list-item" divided @click.native="changePwd">
            <span>修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="0" class="list-item" divided @click.native="goToInfo">
            <span>个人信息</span>
          </el-dropdown-item>
          <el-dropdown-item class="list-item" divided @click.native="logout">
            <span href="javascript:;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>
  </div>
</template>

<script>
  // import LoginApi from '../../../../api/eos/Login'
  import AddressBook from '../../../../api/app/addressBook'
  // import DoUrl from '../../utils/DoUrl'
  export default {
    components: {},
    props: {
      sideBarShow: { default: true }
    },
    data() {
      return {
        userInfo: localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {},
        schoolInfo: {},
        cTitle: window.location.href.indexOf('sysCode=club') != -1 ? '社团管理' : '教学管理平台',
      }
    },
    computed: {},
    methods: {
      toggleSiderBar() {
        this.$emit('update:sideBarShow', !this.sideBarShow)
      },
      // 获取学校信息
      async getSchoolInfo() {
        // this.schoolInfo = await LoginApi.getMySchool()
        // localStorage.schoolName = this.schoolInfo.name
        this.userInfo = await AddressBook.getMyInfo()
      },
      // 修改密码  http://域名
      async changePwd() {
        const eosUrl = `/eos-web/index.html#/updatePwd`
        window.open(eosUrl)
      },
      // 个人中心：http://域名/center/archives/edit?type=0&id=165521
      async goToInfo() {
        // 旧版个人中心
        // const eosUrl = `/center/archives/edit?type=${this.userInfo.type}&id=${this.userInfo.id}&jumpType=1`
        // window.open(await DoUrl.doEosUrl(eosUrl))
        // 新版个人中心
        this.$router.push({ path: '/userCenter/userInfo' })
      },
      logout() {
        this.$confirm('确定要退出吗?', {
          distinguishCancelAndClose: true,
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          Cookies.remove('EOSToken')
          Cookies.remove('EOSSchoolId')
          sessionStorage.clear()
          window.location.href = `/eos-web/index.html#/login`
        }).catch(action => {
          if (action === 'cancel') {
            console.log('cancel')
          }
        })
      },

      goToEos() {
        const eosUrl = `/eos-web/index.html#/index`
        window.open(eosUrl)
      },
    },
    created() {
      this.getSchoolInfo()
    },
  }
</script>

<style lang="less">
  .top-fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    height: 50px;
    z-index: 9;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e6e6e6;
    .header-logo {
      display: flex;
      align-items: center;
      font-size: 20px;
      cursor: pointer;
      img {
        margin-left: 6px;
        height: 44px;
      }
      .ico_menu {
        height: 24px;
        margin-left: 6px;
      }
    }
    .right-tools {
      display: flex;
      align-items: center;
      cursor: pointer;
      .eos-jump {
        padding-right: 30px;
      }
      .avatar-container {
        padding-right: 30px;
      }
    }
  }
</style>

